import { render, staticRenderFns } from "./InstagramPostFilter.vue?vue&type=template&id=3b399078&scoped=true"
import script from "./InstagramPostFilter.vue?vue&type=script&lang=ts"
export * from "./InstagramPostFilter.vue?vue&type=script&lang=ts"
import style0 from "./InstagramPostFilter.vue?vue&type=style&index=0&id=3b399078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b399078",
  null
  
)

export default component.exports